import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackCardTeaserShow } from './tracking';
import { Card } from '../../components/Card';
import { selectFilters } from '../../selectors';
import { EEntityType } from '../../types/filters';
import { IPageState } from '../../types/page';
import { IFavoriteEntity } from '../../types/results';

export interface ICardContainerProps {
  favoriteEntity: IFavoriteEntity;
  page: IPageState;
  total: number;
  position: number;
  removeFavorite(id: number): void;
}

export function CardContainer(props: ICardContainerProps) {
  const { favoriteEntity, position } = props;
  const { entityId } = favoriteEntity;
  const filters = useSelector(selectFilters);

  const handleEntityTrackTeaserShow = React.useCallback(() => {
    if (filters.favoriteEntityType === EEntityType.Newbuilding) {
      return;
    }

    trackCardTeaserShow(entityId, position);
  }, [entityId, filters.favoriteEntityType, position]);

  return (
    <ActionAfterViewObserver
      percentVisible={0.5}
      callback={handleEntityTrackTeaserShow}
      triggerOnce={false}
      callbackDelay={1000}
    >
      <Card {...props} />
    </ActionAfterViewObserver>
  );
}
